export const INIT_NOVALNET_PAYMENT = "INIT_NOVALNET_PAYMENT";
export const GET_ALL_NOVALNET_PAYMENTS = "GET_ALL_NOVALNET_PAYMENTS";
export const SET_NOVALNET_PAYMENTS = "SET_NOVALNET_PAYMENTS";
export const UPDATE_NOVALNET = "UPDATE_NOVALNET";
export const UPDATE_NOVALNET_TOTAL = "UPDATE_NOVALNET_TOTAL";
export const GET_INVOICE = "GET_INVOICE";